import React, { useContext } from "react";
import { SearchContext, MatchContext } from "context/providers";
import Checkbox from "components/base/Checkbox";
import CollapsiblePanel from "./CollapsiblePanel";

const HideUsersFilter = () => {
  const {
    hideSkipped,
    hideRejected,
    hideMatchedAndApplied,
    setHideSkipped,
    setHideRejected,
    setHideMatchedAndApplied,
  } = useContext(SearchContext);

  const { matches } = useContext(MatchContext);

  return (
    <CollapsiblePanel
      header="Hide Users"
      sectionKey="hide-users"
      defaultCollapsed={false}
    >
      <div className="flex flex-col">
        <Checkbox
          label="Hide Skipped Users"
          className="mt-0"
          checked={hideSkipped}
          onChange={(value) => setHideSkipped(value, matches)}
        />
        <Checkbox
          label="Hide Rejected Users"
          className="mt-0"
          checked={hideRejected}
          onChange={(value) => setHideRejected(value, matches)}
        />
        <Checkbox
          label="Hide Matched/Applied Users"
          className="mt-0"
          checked={hideMatchedAndApplied}
          onChange={(value) => setHideMatchedAndApplied(value, matches)}
        />
      </div>
    </CollapsiblePanel>
  );
};

export default HideUsersFilter;
